/**
 * Created by Ning Jiang on 11/15/2018.
 */

import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Timeline, TimelineLite} from "gsap";
import {TombstoneParsedGameData} from "../../server/data/TombstoneParsedGameData";
import {TombstoneGameConfig} from "../../TombstoneGameConfig";
import {TombstoneSoundConfig} from "../../TombstoneSoundConfig";

export class SuperFreespinAttentionController extends ReelStopPresentationController {

    private _bonusPositions:number[];
    private _scatterPositions:number[];
    private _superFreespinTriggeredThisSpin:boolean;
    private _hasBetWayWin:boolean;

    constructor(index:number) {
        super(index, "SuperFreeSpinAttention");
    }

    protected parseFeatureGameData(data:TombstoneParsedGameData):void {
        this._superFreespinTriggeredThisSpin = data.superFreespinTriggeredThisSpin;
        this._bonusPositions = data.bonusPositions;
        this._scatterPositions = data.scatterPositions!;
        this._hasBetWayWin = data.betWins != null && data.betWins.length > 0;
    }

    public onReelBounce(data:IReelStoppedData):void {
        if(data.reelId === 4 && this._superFreespinTriggeredThisSpin) {
            SlotGame.sound.playEffect(TombstoneSoundConfig.instance.BONUS_LANDING_BOUNTY_WIN);
        }

        if(data.reelId != 4 || !this._superFreespinTriggeredThisSpin || !this._hasBetWayWin) {
            this.dispatchCompleteEvent(data.reelId);
            return;
        }

        const timeline:TimelineLite = new TimelineLite();
        timeline.add(this.getSymbolAttention(0, this._bonusPositions[0]), 0);
        timeline.add(this.getSymbolAttention(1, this._scatterPositions[1]), 0);
        timeline.add(this.getSymbolAttention(2, this._scatterPositions[2]), 0);
        timeline.add(this.getSymbolAttention(3, this._scatterPositions[3]), 0);
        timeline.add(this.getSymbolAttention(4, this._bonusPositions[4]), 0);
        timeline.add(() => this.dispatchCompleteEvent(data.reelId));
        timeline.play();
    }

    private getSymbolAttention(reelId:number, symbolId:number):Timeline {
        const symbol:StateReelSymbol | null = Reels.getSymbol(reelId, symbolId);
        if(symbol == null) {
            debugger;
            throw new Error(`SuperFreespinAttentionController.getSymbolAttention(): Cannot find symbol at reelId = ${reelId}, symbolId = ${symbolId}`);
        }

        symbol.parent.addChild(symbol);
        return symbol.changeState({
            state : TombstoneGameConfig.instance.SYMBOL_STATES.attention,
            replay : true,
            fadeInDuration : 0.5,
        })!;
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        if(!data.active) {
            this.dispatchCompleteEvent(data.reelId);
        }
    }
}